import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

export default withStyles({
  root: {
    marginRight: 5,
  },
})(Button);
